/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Logout_Confirmation_TitleInputs */

const de_login_logout_confirmation_title = /** @type {(inputs: Login_Logout_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles erledigt?`)
};

/** @type {(inputs: Login_Logout_Confirmation_TitleInputs) => LocalizedString} */
const en_login_logout_confirmation_title = de_login_logout_confirmation_title;

/**

* @param {Login_Logout_Confirmation_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_logout_confirmation_title = /** @type {((inputs?: Login_Logout_Confirmation_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Logout_Confirmation_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_logout_confirmation_title(inputs)
	return en_login_logout_confirmation_title(inputs)
});